/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
export const COGNITO_CODE_MISMATCH_EXCEPTION = 'CodeMismatchException';
export const COGNITO_LIMIT_EXCEEDED_EXCEPTION = 'LimitExceededException';
export const COGNITO_NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException';
export const COGNITO_USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException';
